import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, theme } from 'antd';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#214797',
            colorSuccess: '#52c41a',
            colorWarning: '#faad14',
            colorError: '#ff4d4f',
            colorInfo: '#214797',
            borderRadius: 4,
            wireframe: false,
          },
          components: {
            Button: {
              borderRadius: 4,
              controlHeight: 36,
            },
            Card: {
              borderRadius: 8,
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
            },
            Layout: {
              bodyBg: '#f0f2f5',
              headerBg: '#214797',
              headerHeight: 64,
              headerPadding: '0 24px',
              footerBg: '#f0f2f5',
              footerPadding: '16px 50px',
            },
            Checkbox: {
              colorPrimary: '#214797',
            },
          },
          algorithm: theme.compactAlgorithm,
        }}
      >
        <App />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);
